import { useVersionDeleted } from './useVersionDeleted'
import { useVersionUploadComplete } from './useVersionUploadComplete'
import { useVersionUploadProcessed } from './useVersionUploadProcessed'
import { useVersionUpdated } from './useVersionUpdated/useVersionUpdated'

export const useVersionSubscriptions = () => {
  useVersionUploadProcessed()

  // Subscription receiving a new version upload
  // Note: the order of these subscriptions matters for handleDocumentUploadEvent test
  useVersionUploadComplete()

  useVersionDeleted()

  useVersionUpdated()
}
